export default {
  order: {
    title: "Commande",
    pickupDate: "Date de prise en charge",
    pickup: "Lieu de prise en charge",
    dropoff: "Lieu de destination",
    passenger: "Passager",
    comment: "Commentaire",
    vehicle: "Véhicule",
    chauffeur: "Chauffeur",
    passengersCount: "Passagers",
    childSeats: "Sièges enfants",
    flightNumber: "Numéro de vol",
    nameSign: "Pancarte avec nom",
    speaks: "Parle",
    call: "Appeler",
    licensePlate: "Plaque d'immatriculation",
    category: "Catégorie",
    status: {
      new: "Confirmation en attente",
      confirmed: "Commande confirmée",
      on_my_way: "En route",
      at_the_location: "Arrivé sur place",
      pob: "Passager à bord",
      clear: "Commande terminée",
      no_show: "Passager non présent",
      canceled: "Commande annulée"
    },
    statusDescriptions: {
      new: "Commande en attente de confirmation du fournisseur",
      confirmed: "Fournisseur a confirmé la commande, en attente de début",
      on_my_way: "Chauffeur en route vers le lieu de prise en charge",
      at_the_location: "Chauffeur arrivé et attend le passager",
      pob: "Passager embarqué, en route vers la destination",
      clear: "Commande terminée avec succès",
      no_show: "Le passager ne s'est pas présenté au lieu de prise en charge",
      canceled: "Commande annulée"
    },
    messages: {
      noChauffeurAssigned: "Votre chauffeur n'a pas encore été assigné",
      detailsWillAppear: "Les détails apparaîtront ici une fois assignés",
      unknown: "Inconnu",
      started: "Démarré",
      awaitingAssignment: "En attente d'assignation"
    },
    childSeatsTypes: {
      child_01: "Siège nourrisson (6 mois)",
      child_02: "Siège convertible (0-7 ans)",
      child_03: "Réhausseur (6-12 ans)"
    },
    distance: "{distance} km",
    review: "Évaluez votre voyage",
    review_status: {
      perfect: 'Parfait',
      good: 'Bon',
      average: 'Moyen',
      bad: 'Mauvais',
      terrible: 'Exécrable'
    }
  },
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    loading: "Chargement...",
    error: "Erreur"
  }
}